import { Info, ShieldCheck, type LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface RagPermissionNoteProps {
  variant: "info" | "admin";
  children: React.ReactNode;
  className?: string;
}

const VARIANTS: Record<
  RagPermissionNoteProps["variant"],
  { icon: LucideIcon; className: string }
> = {
  info: {
    icon: Info,
    className: "border-amber-500/30 bg-amber-500/8 text-amber-200",
  },
  admin: {
    icon: ShieldCheck,
    className: "border-amber-500/30 bg-amber-500/8 text-amber-200",
  },
};

export function RagPermissionNote({ variant, children, className }: RagPermissionNoteProps) {
  const { icon: Icon, className: variantClass } = VARIANTS[variant];

  return (
    <div
      className={cn(
        "mb-5 flex items-center gap-2 rounded-[10px] border px-3 py-2.5 text-xs",
        variantClass,
        className
      )}
    >
      <Icon className="h-4 w-4 shrink-0" />
      <span>{children}</span>
    </div>
  );
}
